import { render, staticRenderFns } from "./AdminPanelEGiftsPackageSelling.vue?vue&type=template&id=1f0ac5a8&"
import script from "./AdminPanelEGiftsPackageSelling.vue?vue&type=script&lang=js&"
export * from "./AdminPanelEGiftsPackageSelling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports